import { useEffect, useMemo, useState } from "react";
import { Button } from "../components/Button";
import { Modal } from "../components/Modal";
import { Typography } from "../components/Typography";
import { getBookingSuccessType } from "../../../APIDocs/apiTypes"
import { useStoreBookingForRebooking } from "../hooks/useStoreBooking";
import { useNav } from "../hooks/useNav";
import { useNavigate } from "react-router-dom";
import { useIsInternalUser, useIsSupplierUser, useGetUserType } from "../hooks/useUserPermissions";
import { useModel } from "../hooks/useModel";


export interface props {
    bookingId: string,
    mpan: string,
    serviceLine: string
    booking: getBookingSuccessType
}

export const RebookJob = (props: props) => {

    const [showRebookModal, setShowRebookModal] = useState(false);
    const modalTitle = "Rebook Job";
    const nav = useNavigate();
    const model = useModel();
    const storeBooking = useStoreBookingForRebooking();
    useEffect(() => {
        storeBooking.storeSite(props.booking, props.serviceLine, props.bookingId);
    }, []);

    const currentSiteType = model.Get('viewModel.fetchedData.siteData.siteType');

    const canRebook = useMemo(() => {
        if (!props.booking.JobTypeCode) return false;
        const splitJobCode = props.booking.JobTypeCode.split("_");
        if (splitJobCode.length < 2) return false;
        if (['DNO', 'BNO'].includes(props.serviceLine)) {
            return currentSiteType === splitJobCode[0];
        }
        const bookingSiteType = `${splitJobCode[0]} ${splitJobCode[1]}`;
        return currentSiteType === bookingSiteType;
    }, [currentSiteType, props.booking.JobTypeCode]);

    const navigateToGetOffers = () => {
        if(useIsInternalUser()) {
            useNav(`/bookJob/internalOffers/${props.mpan}/${props.serviceLine}`, nav);
        }
        else if(useIsSupplierUser()) {
            useNav(`/bookJob/offers/${props.mpan}/${props.serviceLine}`, nav);
        }
    }

    return (
        <div>
            {
                useGetUserType() != undefined ?
                    <Button text="Rebook Job" primary={true} onClick={() => { setShowRebookModal(true) }} disabled={false} className="mt-2 inline-block" />
                    :
                    <span></span>
            }
            {
                showRebookModal ?
                    <Modal title={modalTitle} >
                        <Typography content={canRebook ? `Confirm you wish to rebook this job. All details/comments from this job will be carried over to the new booking.` : `The job you're attempting to rebook does not match the current site type ${currentSiteType}. To progress, please raise a new job against the correct site type.`} className="mb-3" />
                        <Button primary={false} text="OK" className="mr-4 mt-5" disabled={!canRebook} onClick={() => navigateToGetOffers()}/>
                        <Button primary={false} text="Cancel" className="mr-4 mt-5" disabled={false} onClick={() => setShowRebookModal(false)} />
                    </Modal>
                    :
                    <span></span>
            }
        </div>
    )
}
